import React from 'react';
import { Box, Flex, Stack, Text, HStack } from '@chakra-ui/react';
import { Button, Heading } from '~/components';
import { useDeleteEquipmentDuplicates } from '~/hooks/useEquipments';
import {
  useDeleteContractDuplicates,
  useDialog,
  useResetContracts,
} from '~/hooks';
import { useInit } from '~/hooks/useInit';

export const ResetCache: React.VFC = () => {
  const { getConfirmation } = useDialog();
  const { isLoading: isEquipmentLoading, mutateAsync: equipmentMutateAsync } =
    useDeleteEquipmentDuplicates();
  const { isLoading: isContractLoading, mutateAsync: contractMutateAsync } =
    useDeleteContractDuplicates();
  const { isLoading: isResetLoading, mutateAsync: resetMutateAsync } =
    useResetContracts();
  const { isLoading: isInitLoading, mutateAsync: initMutateAsync } = useInit();

  async function handleContracts() {
    contractMutateAsync({});
  }

  async function handleEquipments() {
    equipmentMutateAsync({});
  }

  async function handleReset() {
    const isConfirmed = await getConfirmation({
      title: 'Atenção',
      text: 'Tem certeza que deseja prosseguir? Todas os registros das tabelas de Contratos e Equipamentos serão apagados.',
    });

    if (isConfirmed) resetMutateAsync({});
  }

  async function handleInit() {
    const isConfirmed = await getConfirmation({
      title: 'Atenção',
      text: 'Tem certeza que deseja prosseguir? O /init preencherá as tabelas bases necessárias para o sistema',
    });

    if (isConfirmed) initMutateAsync({});
  }

  return (
    <Box px="8" py="4">
      <Heading hasBackButton>Remover Duplicidades</Heading>
      <Flex
        flexDir="row"
        flexWrap="wrap"
        w="100%"
        py={9}
        gridGap="12"
        style={{
          position: 'relative',
        }}
        fontSize="14px"
      >
        <Flex>
          <Stack gridGap={10}>
            <Text>
              Contratos de teste ou equipamentos duplicados podem ser removidos
              utilizando os botões abaixo:
            </Text>
          </Stack>
        </Flex>
      </Flex>
      <HStack gap={3}>
        <Button isLoading={isContractLoading} onClick={() => handleContracts()}>
          Remover contratos teste
        </Button>
        <Button
          isLoading={isEquipmentLoading}
          onClick={() => handleEquipments()}
        >
          Remover Equipamentos duplicados
        </Button>
      </HStack>
      <HStack gap={3} mt={8}>
        <Button isLoading={isResetLoading} onClick={() => handleReset()}>
          Limpar Contratos e Equipamentos
        </Button>
        <Button isLoading={isInitLoading} onClick={() => handleInit()}>
          Inicializar dados
        </Button>
      </HStack>
    </Box>
  );
};
